import { BodyText, Icon } from '@servicetitan/design-system';
import { FC } from 'react';
import { Centered } from './centered';

const ErrorMessage: FC<{ text: string }> = ({ text }) => (
    <Centered>
        <Icon name="error" className="c-red-500 m-b-1" size={48} />
        <BodyText>{text}</BodyText>
    </Centered>
);

export { ErrorMessage as Error };
